<template>
    <k-page background="bg-white">
        <template v-slot:header>
            <public-header/>
        </template>
        <k-container class="py-10">
            <div class="max-w-lg mx-auto">
                <k-alert class="mb-6" v-if="tokenExpired">
                    <template slot="text">{{ $t("tokenExpired") }}</template>
                    <div slot="description">
                        {{ $t("redirectingToLogin") }}
                        <a-icon type="loading"/>
                    </div>
                </k-alert>
                <k-alert class="mb-6" v-if="passwordChanged">
                    <template slot="text">{{ $t("passwordHasChanged") }}</template>
                    <div slot="description">
                        {{ $t("redirectingToLogin") }}
                        <a-icon type="loading"/>
                    </div>
                </k-alert>
                <div v-if="!passwordChanged && !tokenExpired">
                    <h3 class="font-bold text-2xl mb-4">{{ $t("resetPassword") }}</h3>
                    <p class="text-sm mb-6">{{ $t("passwordCriteria") }}</p>
                    <form autocomplete="off">
                        <k-input
                                class="mb-4"
                                id="password"
                                label="Password"
                                v-model="form.password"
                                :field-errors="validation.fieldErrors"
                                type="password"/>
                        <k-input
                                class="mb-4"
                                id="passwordRepeat"
                                label="Confirm password"
                                v-model="form.passwordRepeat"
                                :field-errors="validation.fieldErrors"
                                type="password"/>
                        <div class="mt-6">
                            <k-button @click.native.prevent="onSubmit">
                                {{ $t("resetPassword") }}
                            </k-button>
                        </div>
                    </form>
                </div>
            </div>
        </k-container>
        <template v-slot:footer>
            <k-footer/>
        </template>
    </k-page>
</template>

<script>
    import PublicHeader from '@investor/components/PublicHeader';

    export default {
        components: {
            PublicHeader,
        },
        data() {
            return {
                tokenExpired: false,
                passwordChanged: false,
                form: {
                    password: null,
                    passwordRepeat: null,
                    token: null
                },
                validation: {
                    fieldErrors: {}
                }
            }
        },
        methods: {
            async onSubmit() {
                this.validation = {
                    fieldErrors: {}
                };
                try {
                    await this.$post('public/reset-password', this.form);
                    this.passwordChanged = true;
                    setTimeout(() => this.$router.push('/'), 3000);
                } catch (error) {
                    if (error.response && error.response.status === 400) {
                        this.validation = error.response.data;
                        this.$scrollToErrorField();
                    }
                }
            },
            fieldError(field) {
                return this.validation.fieldErrors[field];
            },
        },
        async created() {
            this.form.token = this.$route.params.token;
            try {
                let res = await this.$post('public/validate-reset-password-token', {token: this.form.token});
                if (!res.valid) {
                    this.tokenExpired = true;
                    setTimeout(() => this.$router.push('/'), 3000);
                }
            } catch (e) {
                this.$router.push('/');
            }
        }
    }
</script>


